import { useTheme } from '../../contexts/Theme';
import {
  BUTTON_VARIANTS,
  IconDescription
} from 'cdk-radial';
import { usePaneManagement } from '../../contexts/PaneManagementContext';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import { TextButton } from '../Buttons/TextButton';
import { Button } from '../Buttons/Button';
import {
  Dialog
} from 'cdk-radial';
import styled from "styled-components";
import { useAdoptEaseStore } from '../../Store/useAdoptEaseStore'
import { useHistory } from 'react-router-dom';
import {useEffect} from 'react';
import { 
  useUpdateUserAdoptEaseUsage
} from '../../hooks/queries';
import { IAdoptEaseWorkflow} from "../../types"
import { useTranslation } from 'react-i18next';
import launchExternal from '../../util/launchExternal';

export const StyledIconDescription = styled(IconDescription)`
  width: 30px;
  height: 30px;
  fill: #196FE1;
;
`;

export const StyledDiv = styled.div`
 display: flex;
 @media (max-width: 625px) {
    display: grid;
  }
`

export const StyledDialog = styled(Dialog)`
  min-width: 560px;
  max-width: 700px;
  width: 60vw;
  margin-top: 60px;
  z-index: 9999;
  height: auto;
  max-height: 400px;
  font-size: 24px;
  font-weight: 800;
  @media (max-width: 958px) {
    width: 92vw;
  }
  @media (max-width: 470px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
    top: 310px;
  }
  @media (max-width: 570px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
  }
`;

const customFooter = (props: {onClose: Function, onProceed: Function }) => () => {
  const { darkMode } = useTheme();
  const { trackEvent } = useAnalytics();
  const history = useHistory();
  const { mutate: mutateAdoptEaseUpdate } = useUpdateUserAdoptEaseUsage();
  const workflows = useAdoptEaseStore((state: any) => state.adoptEaseWorkflows) as IAdoptEaseWorkflow[];
  const { t } = useTranslation();

  const updateAdoptEaseUsage = () => {
    const now = (new Date());
    const record: Record<string, Date> = workflows.reduce<Record<string, Date>>((accumulated, item) => {
      accumulated[item!.workflow.toString()] = now;
      return accumulated;
    }, {});

    mutateAdoptEaseUpdate(record);
  };

  return (
    <StyledDiv style={{
      padding: '50px 16px 16px 5px',
      justifyContent: 'space-between'
    }}>
      <TextButton style={{ color: "#196FE1", fontSize: "14px", fontWeight: "550", minWidth: "170px", maxWidth: "190px" }} darkMode={darkMode} 
       text={t('adoptease.proceed_drive')} 
       onClick={() => {
        props.onClose();
        props.onProceed();
      }} />
      <div>

        <Button style={{ backgroundColor: '#E8F1FC', color: '#155EBF', fontSize: "14px", fontWeight: "500" }} darkMode={darkMode} 
        variant={BUTTON_VARIANTS.PRIMARY} text={t('adoptease.remind_me')}
         onClick={() => {
          trackEvent(AMPLITUDE_EVENTS.RECOMMENDATION_REMIND_ME);
          props.onClose();
          props.onProceed();
          updateAdoptEaseUsage();
        }
        } />

        <Button style={{ backgroundColor: '#196FE1', fontSize: "14px", fontWeight: "500", marginLeft: "10px" }} darkMode={darkMode} variant={BUTTON_VARIANTS.PRIMARY} 
        text={t('adoptease.go_workflow')}
         onClick={() => {
          trackEvent(AMPLITUDE_EVENTS.OPEN_RECOMMENDATION_WORKFLOW);
          history.push(`workflows`);
          props.onClose();
        }
        } />
      </div>

    </StyledDiv>)
}

const AdoptEaseDialog = (props: {
  isOpen: boolean,
  onClose: Function,
  onProceed: Function
}): JSX.Element => {
  const { openCdkuPane } = usePaneManagement();
  const { t } = useTranslation();

  const onCdkuOpen = (url: string) => {
    openCdkuPane('CDKU', url);
  };

  const { trackEvent } = useAnalytics();

  const adoptEaseWorkflows = useAdoptEaseStore((state: any) => state.adoptEaseWorkflows);
  const adoptEaseConfigData = useAdoptEaseStore((state: any) => state.adoptEaseConfigData);

  useEffect(() => {
    if (props.isOpen) {
      trackEvent(AMPLITUDE_EVENTS.RECOMMENDATION_MODAL_SEEN, {'Workflows': JSON.stringify(adoptEaseWorkflows || [])});
    }
  }, [props.isOpen, trackEvent, adoptEaseWorkflows]); 

  return (
    <div>
      <StyledDialog
        isOpen={props.isOpen}
        id="recomm-dialog"
        data-testid="adoptease-recomm-dialog"
        onClose={props.onClose}
        title= {t('adoptease.recommended')}
        renderCustomFooterComponent={customFooter(props)}
        hideCloseButton={true}
        disableOverlayClicked={true}
      >
        {adoptEaseWorkflows?.length === 1 ?
          <div style={{ fontSize: "14px", fontWeight: "350" }} >{`${t('adoptease.notice_workflow')} ${adoptEaseWorkflows[0].function}. ${t('adoptease.encourage_workflow')} ${adoptEaseWorkflows[0].modernWorkflow}.`}</div>

          :
          <div style={{ fontSize: "14px", fontWeight: "350" }} >{t('adoptease.notice_workflows')}</div>
        }
        <div>
          
          {adoptEaseWorkflows?.length === 1 ?
          <div>
            <br />
            <div style={{ fontSize: "14px", fontWeight: "350" }} >{t('adoptease.review')} </div>
             <br />
            <StyledIconDescription />
            <TextButton style={{ color: "#196FE1", fontSize: "14px", fontWeight: "600", bottom: "10px" }} text={`${adoptEaseWorkflows[0].modernWorkflow} ${t('adoptease.help')}`} onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.OPEN_RECOMMENDATION_HELP);
              launchExternal(adoptEaseConfigData?.find((item: any) => item.workflow === adoptEaseWorkflows[0].modernWorkflow)?.workflowHelpLink) || onCdkuOpen(adoptEaseConfigData?.find((item: any) => item.workflow === adoptEaseWorkflows[0].modernWorkflow)?.workflowHelpLink)
              props.onClose();
            }} /> </div>:
            <div>
              <br />
              <div style={{ fontSize: "14px", fontWeight: "350" }} >{t('adoptease.review')} </div>
              <br />
              <StyledIconDescription />
            <TextButton style={{ color: "#196FE1", fontSize: "14px", fontWeight: "600", bottom: "10px" }} text={`Dealership Accounting ${t('adoptease.help')}`} onClick={() => {
              trackEvent(AMPLITUDE_EVENTS.OPEN_RECOMMENDATION_HELP);
              launchExternal(adoptEaseConfigData?.find((item: any) => item.workflow === adoptEaseWorkflows[0].modernWorkflow)?.appHelpLink) || onCdkuOpen(adoptEaseConfigData?.find((item: any) => item.workflow === adoptEaseWorkflows[0].modernWorkflow)?.appHelpLink)
              props.onClose();
            }} /></div>
          }
        </div>
      </StyledDialog>
    </div>
  );
};
export default AdoptEaseDialog;
